import FormulaEdge from './FormulaEdge';

const edgeTypes = { formulaEdge: FormulaEdge };

export default edgeTypes;
